import { downloadFile } from '../../../shared/api/download';

export function downloadQueue(): Promise<void> {
    const today = new Date().toLocaleDateString('ru-RU');

    return downloadFile(
        `/api/admin/standard_size_report/export?start_date=2020-01-01&end_date=${today}`,
        `Справочник неподтвержденных габаритов ЯНАО на ${today}.xlsx`,
    );
}

export function downloadSizes(): Promise<void> {
    const today = new Date().toLocaleDateString('ru-RU');

    return downloadFile(
        `/api/reports/standard_size_report/exel`,
        `Справочник эталонных габаритов ЯНАО на ${today}.xlsx`,
    );
}
